export default "__VITE_ASSET__89c6e591__"